module.exports = __webpack_public_path__ + "/assets/under_construction.png";


/*****************
 ** WEBPACK FOOTER
 ** ../src/dash/front/styles/images/under_construction.png
 ** module id = 1060
 ** module chunks = 0
 **/